import script from "./LinkCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkCard.vue?vue&type=script&setup=true&lang=js"

import "./LinkCard.vue?vue&type=style&index=0&id=052c989a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-052c989a"]])

export default __exports__